export default "__VITE_ASSET__DPxqFvfh__"